<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section [style.background-color]="'#fff'" class="ai_cab_booking">
  <header class="cab_chat_header">
    <div class="cab_chat_header_brand">
      <figure>
        <img [src]="assetsConst.chatBotLogo" alt="logo" />
      </figure>
      <h2 [title]="headerTitle()">{{ headerTitle() }}</h2>
    </div>
    <div class="cab_chat_header_actions">
      <p-button class="cab_chat_close" (click)="closeAI()">
        <img [src]="assetsConst.aiCross" alt="" />
      </p-button>
      <button type="button" class="cab_chat_mute" (click)="toggleMute()">
        @if (isMuted() === false) {
          <img [src]="assetsConst.voulmeOn" alt="" />
        } @else {
          <img [src]="assetsConst.voulmeOff" alt="" />
        }
      </button>
    </div>
  </header>

  <div class="cab_chat_body">
    <div
      class="cab_chat_body_scroll"
      infiniteScroll
      [infiniteScrollUpDistance]="1.1"
      [infiniteScrollThrottle]="50"
      [scrollWindow]="false"
      (scrolledUp)="onHistoryScrolledUp()"
      #chatContainer>
      <div class="user_msg">
        @if (isLoadingMessages() && !historyFullyLoaded()) {
          <div class="history_loader" aria-label="Loading messages">
            <span></span>
          </div>
        }
        @for (
          list of messagesData();
          track trackChatMessage($index, list);
          let i = $index
        ) {
          @if (shouldShowChatMessage(list)) {
            @if (list.role === 'system' || list.role === 'info') {
              <div
                class="chat_status_message"
                [class.is_info]="list.role === 'info'">
                <p>{{ list.message }}</p>
              </div>
            } @else if (list.role === 'agent') {
              <div class="ai_chat agent_chat">
                <figure>
                  <img [src]="assetsConst.agent" alt="" />
                </figure>
                <div class="ai_chat_content">
                  @if (list.displayedMessage || list.message) {
                    <logibids-linkified-text
                      [text]="list.displayedMessage || list.message"
                      [markdown]="true"
                      textClass="cab_booking_head text-left" />
                  }
                  @if (shouldShowHelpGuideLink(list)) {
                    <button
                      type="button"
                      class="help_guide_link_btn"
                      (click)="navigateToHelpGuide(list.helpGuideSlug!)">
                      {{ 'GuideLink' | translate }}
                    </button>
                  }
                  @if (shouldShowMessageMedia(list)) {
                    <ng-container
                      *ngTemplateOutlet="
                        chatMediaTpl;
                        context: { $implicit: list.media }
                      " />
                  }
                  @if (list.created_at) {
                    <time class="chat_timestamp">{{
                      formatMessageTimestamp(list.created_at)
                    }}</time>
                  }
                </div>
              </div>
            } @else if (list.role === 'ai' || list.sender === false) {
              <div class="ai_chat">
                <figure>
                  <img [src]="list.sender_photo || assetsConst.Ai" alt="" />
                </figure>
                <div class="ai_chat_content">
                  @if (list.displayedMessage) {
                    <logibids-linkified-text
                      [text]="list.displayedMessage"
                      [markdown]="true"
                      textClass="cab_booking_head text-left" />
                  } @else if (shouldShowAiMessageLoader(list)) {
                    <div
                      class="history_loader ai_voice_loader"
                      aria-label="Preparing response">
                      <span></span>
                    </div>
                  }
                  @if (shouldShowHelpGuideLink(list)) {
                    <button
                      type="button"
                      class="help_guide_link_btn"
                      (click)="navigateToHelpGuide(list.helpGuideSlug!)">
                      {{ 'GuideLink' | translate }}
                    </button>
                  }
                  @if (shouldShowMessageMedia(list)) {
                    <ng-container
                      *ngTemplateOutlet="
                        chatMediaTpl;
                        context: { $implicit: list.media }
                      " />
                  }
                  @if (shouldShowMessageOptions(list)) {
                    <ul class="ai_chat_options" role="listbox">
                      @for (option of list.options; track option.name) {
                        <li
                          role="option"
                          [attr.aria-selected]="
                            list.selectedOption === option.name
                          "
                          [class.is_readonly]="!canSelectOption(list, i)"
                          (click)="
                            canSelectOption(list, i)
                              ? onOptionSelected(list, option)
                              : null
                          ">
                          <span>{{ option.name }}</span>
                        </li>
                      }
                    </ul>
                  }
                  @if (list.created_at) {
                    <time class="chat_timestamp">{{
                      formatMessageTimestamp(list.created_at)
                    }}</time>
                  }
                </div>
              </div>
            } @else {
              <div class="sender">
                <figure>
                  <img [src]="assetsConst.userAI" alt="" />
                </figure>
                <div class="sender_content">
                  @if (list.message) {
                    <logibids-linkified-text [text]="list.message" />
                  }
                  @if (list.media && list.media.length > 0) {
                    <ng-container
                      *ngTemplateOutlet="
                        chatMediaTpl;
                        context: { $implicit: list.media }
                      " />
                  }
                  @if (list.created_at) {
                    <time class="chat_timestamp">{{
                      formatMessageTimestamp(list.created_at)
                    }}</time>
                  }
                </div>
              </div>
            }
          }
        }
        @if (shouldShowAwaitingBotBubble()) {
          <div class="ai_chat ai_chat_pending">
            <figure>
              <img [src]="assetsConst.Ai" alt="" />
            </figure>
            <div class="ai_chat_content">
              <div
                class="history_loader ai_voice_loader"
                aria-label="Waiting for response">
                <span></span>
              </div>
            </div>
          </div>
        }
        @if (isUploadingMedia()) {
          <div
            class="history_loader media_upload_loader"
            aria-label="Uploading media">
            <span></span>
          </div>
        }
      </div>
    </div>
    <div
      class="ai_orb_wrap"
      [style.transform]="'translate(-50%, -50%) scale(' + volumeScale() + ')'">
      <video
        #aiVideo
        class="video ai_orb_video"
        [muted]="true"
        [loop]="true"
        autoplay
        playsinline>
        <source src="assets/images/ai.mp4" type="video/mp4" />
      </video>
    </div>
  </div>

  <div class="cab_chat_foot">
    <div class="send_msg">
      <div
        class="control_group"
        [class.is_disabled]="isInputDisabled()"
        [class.has_upload]="chatMode() === 'HYBRID' && activeAgentName()">
        <p-iconField iconPosition="right">
          @if (chatMode() === 'HYBRID' && activeAgentName()) {
            <p-inputIcon
              styleClass="ai-camera-icon"
              (click)="!isInputDisabled() ? onCameraClick() : null">
              <img [src]="assetsConst.cameraIcon" alt="camera" />
            </p-inputIcon>

            <p-inputIcon
              styleClass="ai-attach-icon"
              (click)="!isInputDisabled() ? mediaInput.click() : null">
              <img [src]="assetsConst.attachIcon" alt="upload media" />
            </p-inputIcon>
          }

          <p-inputIcon
            styleClass="ai-send-icon"
            (click)="!isInputDisabled() ? send() : null">
            <img src="assets/images/send_icon.svg" alt=" send icon" />
          </p-inputIcon>

          <input
            type="text"
            pInputText
            logibidsSpaceAtFirst
            placeholder="{{ 'Typeyourmessage' | translate }}"
            [formControl]="messageControl"
            (focus)="onComposerFocus()"
            (input)="onUserTyping()"
            (keyup.enter)="!isInputDisabled() && send()" />
        </p-iconField>

        <input
          #mediaInput
          type="file"
          accept="image/*,application/pdf"
          multiple
          hidden
          (change)="onMediaSelected($event)" />
      </div>
      <p-button
        [disabled]="isMicDisabled()"
        [class.is_listening]="isListening()"
        (click)="onMicClick()"
        [attr.aria-pressed]="isListening()"
        [attr.aria-label]="
          isListening() ? 'Stop listening' : 'Start voice input'
        ">
        <img [src]="assetsConst.aiMikeIcon" alt="" />
      </p-button>
    </div>
  </div>
</section>

<ng-template #chatMediaTpl let-mediaList>
  <div
    class="chat_media"
    [class.is_documents_only]="isDocumentsOnlyMedia(mediaList)">
    @for (media of mediaList; track $index) {
      @if (isPdf(media)) {
        <a
          class="media_doc"
          [href]="media"
          target="_blank"
          rel="noopener noreferrer">
          <img
            [src]="assetsConst.chatDocumentIcon"
            alt=""
            class="media_doc_icon" />
          <span>{{ 'Document_ai' | translate }}</span>
        </a>
      } @else if (isVideo(media)) {
        <a
          class="media_video"
          [href]="media"
          target="_blank"
          rel="noopener noreferrer">
          <video [src]="media" preload="metadata" muted playsinline></video>
          <span class="media_video_play" aria-hidden="true">
            <i class="pi pi-play"></i>
          </span>
        </a>
      } @else if (isImage(media)) {
        <a
          class="media_img"
          [href]="media"
          target="_blank"
          rel="noopener noreferrer">
          <img [src]="media" alt="media" />
        </a>
      } @else {
        <a
          class="media_doc"
          [href]="media"
          target="_blank"
          rel="noopener noreferrer">
          <img
            [src]="assetsConst.chatDocumentIcon"
            alt=""
            class="media_doc_icon" />
          <span>{{ 'Document_ai' | translate }}</span>
        </a>
      }
    }
  </div>
</ng-template>
